import { bindable, computedFrom } from 'aurelia-framework';
import { Uuid } from '../../helpers/uuid';

export class CardLogo {
	@bindable cardType: any;

	/**
	 * Used as a workaround for WCAG accessibility to distinguish where on the page this logo falls
	 * to prevent screen reader confusion confusion with other insertions of this template.
	 */
	uniqueID: string;

	constructor() {
		this.uniqueID = Uuid.next();
	}

	@computedFrom('cardType')
	get cardName() {
		try {
			switch (this.cardType) {
				case 'AMEX':
					return 'American Express';
				case 'CARTEBLANC':
					return 'Carte Blanc';
				case 'DINERS':
					return 'Diners Club';
				case 'DISCOVER':
					return 'Discover';
				case 'JCB':
					return'JCB';
				case 'MASTERCARD':
					return 'MasterCard';
				case 'VISA':
					return 'Visa';
				default:
					return '';
			}
		}
		catch (err) {
			return '';
		}
	}

	@computedFrom('cardName')
	get cardAltText() {
		return this.cardName + ' Card';
	}

	@computedFrom('cardType')
	get cardLogoUrl() {
		const visaCardLoc = require('../../images/cards/visa.png');
		const mcCardLoc = require('../../images/cards/mastercard_logo.png');
		const amexCardLoc = require('../../images/cards/amex_logo.png');
		const discCardLoc = require('../../images/cards/discover.png');
		const dinersCardLoc = require('../../images/cards/diners.png');
		const jcbCardLoc = require('../../images/cards/jcb.png');

		try {
			switch (this.cardType) {
				case 'AMEX':
					return amexCardLoc;
				case 'CARTEBLANC':
				case 'DINERS':
					return dinersCardLoc;
				case 'DISCOVER':
					return discCardLoc;
				case 'JCB':
					return jcbCardLoc;
				case 'MASTERCARD':
					return mcCardLoc;
				case 'VISA':
					return visaCardLoc;
				default:
					return '';
			}
		}
		catch (err) {
			return '';
		}
	}

	@computedFrom('cardType')
	get cardClass() {
		const visa = 'card-visa';
		const mc = 'card-mastercard';
		const amex = 'card-amex';
		const disc = 'card-discover';
		const diners = 'card-diners';
		const jcb = 'card-jcb';

		try {
			switch (this.cardType) {
				case 'AMEX':
					return amex;
				case 'CARTEBLANC':
				case 'DINERS':
					return diners;
				case 'DISCOVER':
					return disc;
				case 'JCB':
					return jcb;
				case 'MASTERCARD':
					return mc;
				case 'VISA':
					return visa;
				default:
					return '';
			}
		}
		catch (err) {
			return '';
		}
	}
}
